/* eslint-disable */
/* Fork from https://github.com/medic/lucene-query-generator/blob/master/generator.js
 * ProtectWise changes:
 * - Allow field keys to be passed without being escaped (escapeKeys:true/false, true by default)
 * - Removed datatype suffixes from formatted field keys
 * - Added formatters for numeric datatypes
 * - Modified date formatter to output numeric timestamps
 * - Modified formatValue() to bypass formatting for wildcard char ("*")
 * - Fixed bug where allowSpecialCharacters on any field would clobber that datatype's formatter globally
 * - Added some more string special chars (forward slash, whitespace) that require wrapping in quotes
 */


var types = {
  string: {
    suffix: '',
    format: function(str) {
      str = str.replace(/"/g, '\\"')
      if (str.match(/([\+\-&\|\!\(\)\{\}\[\]\^"~\*?:\\\/\s])/g)) {
        return '"' + str + '"'
      }
      return str
    }
  },
  int: {
    suffix: '', //'<int>'
    format: v => '' + parseInt(v, 10)
  },
  long: {
    suffix: '', //'<long>'
    format: v => '' + parseFloat(v)
  },
  float: {
    suffix: '', //'<float>'
    format: v => '' + parseFloat(v)
  },
  double: {
    suffix: '', //'<double>'
    format: v => '' + parseFloat(v)
  },
  boolean: {
    suffix: '',
    format: v => '' + (!!v && v !== 'false')
  },
  date: {
    suffix: '', //'<date>',
    format: v => '' + (+v) //allows a number, number as string, or Date object
  },
  geo: {
    suffix: '',
    format: v => {
      return v
    }
  }
}

var operators = {
  and: {
    symbol: 'AND'
  },
  or: {
    symbol: 'OR'
  },
  not: {
    symbol: 'NOT',
    unary: true
  }
}

var getType = function(field, schema) {
  if (schema[field]) {
    if (schema[field].type) {
      return types[schema[field].type]
    }
    return types[schema[field]]
  }
  return types.string
};

var getOperator = function(code) {
  var normalised = code && code.toLowerCase()
  return (normalised && operators[normalised]) || operators.and
};

var isString = function(obj) {
  return typeof obj === 'string' || obj instanceof String
};

var isArray = function(obj) {
  return Object.prototype.toString.call(obj) === '[object Array]'
};

var isDefined = function(obj) {
  return obj !== null && obj !== undefined
};

var escapeKey = function(str) {
  var i = str.length
  var result = []
  while (i--) {
    var c = str[i]
    if (c == '\\' || c == '+' || c == '-' || c == '!' || c == '(' || c == ')' || c == ':' || c == '^' || c == '[' || c == ']' || c == '\"' || c == '{' || c == '}' || c == '~' || c == '*' || c == '?' || c == '|' || c == '&') {
      result[i] = '\\' + c
    } else {
      result[i] = c
    }
  }
  return result.join('')
};

var createDisjunction = function(array) {
  if (array.length === 0) {
    return null
  }
  if (array.length === 1) {
    return array[0]
  }
  return '(' + array.join(' OR ') + ')'
};

/**
 * Returns the formatted value or null
 */
var formatValue = function(type, value) {
  if (isArray(value)) {
    var values = []
    value.forEach(function(item) {
      var value = formatValue(type, item)
      if (isDefined(value)) {
        values.push(value)
      }
    })
    return createDisjunction(values)
  }
  if (isDefined(value.$from) && isDefined(value.$to)) {
    var from = formatValue(type, value.$from)
    var to = formatValue(type, value.$to)
    if (!isDefined(from) || !isDefined(to)) {
      return null
    }
    return '[' + formatValue(type, value.$from) +
        ' TO ' + formatValue(type, value.$to) + ']'
  }
  return (type.format && value !== '*') ? type.format(value) : value
};

var extractTerms = function(obj, schema, escapeKeys) {
  if (isString(obj)) {
    return [ obj ]
  }
  var result = []
  Object.keys(obj).forEach(function(field) {
    if (isDefined(obj[field])) {
      var type = getType(field, schema)
      // Dont format if allowSpecialCharacters is true
      if (schema[field] && schema[field].allowSpecialCharacters) {
        type = Object.assign({}, type, {format: false})
      }
      var value = formatValue(type, obj[field])
      if (isDefined(value)) {
        result.push((escapeKeys ? escapeKey(field) : field) + type.suffix + ':' + value)
      }
    }
  })
  return result
};

var extractOperands = function(operands, schema, escapeKeys) {
  var results = []
  if (isArray(operands)) {
    operands.forEach(function(operand) {
      if (operand.$operands) {
        var unary = getOperator(operand.$operator).unary
        var term = convert(operand, { schema: schema, escapeKeys: escapeKeys })
        results.push(unary ? term : '(' + term + ')')
      } else {
        results.push.apply(results, extractTerms(operand, schema, escapeKeys))
      }
    })
  } else {
    results.push.apply(results, extractTerms(operands, schema, escapeKeys))
  }
  return results
};

var joinOperands = function(operands, code) {
  var operator = getOperator(code)
  var prefix = operator.unary ? operator.symbol + ' ' : ''
  return prefix + operands.join(' ' + operator.symbol + ' ')
};

export function convert (terms, options={}) {
  const {
    schema={},
    escapeKeys=true
  } = options || {}
  var operands = extractOperands(terms.$operands || [], schema, escapeKeys)
  return joinOperands(operands, terms.$operator)
};
